import { render } from "./ClientHistory.vue?vue&type=template&id=0132b217"
import script from "./ClientHistory.vue?vue&type=script&lang=js"
export * from "./ClientHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__